export default [
	{
		path: '/manage/repairRecord/:id',
		component: (resolve) => require(['../page.vue'], resolve),
		meta: {
			title: '修护记录',
			keepAlive: false,
		},
	},
]
